import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../../../store';
import { isLayoutViewActive } from '../../../../../store/selectors/layoutModeSelectors';
import { getPickingObjectInfoType } from '../../../../../store/selectors/pickingSelectors';
import { getWorkLineInsertionInfo } from '../../../../../store/selectors/workLineInsertionSelectors';

export const areSnappingSettingsRelevant = createSelector(
  isLayoutViewActive,
  (state: RootState) => state.application.inDimensionMode,
  getPickingObjectInfoType,
  getWorkLineInsertionInfo,

  (layoutViewActive, inDimensionMode, pickingObjectType, workLineInsertion) =>
    layoutViewActive &&
    (inDimensionMode ||
      pickingObjectType === 'pickingLayoutPoint' ||
      (workLineInsertion && workLineInsertion.draft.phase !== 'reviewing')),
);
